module.exports = __webpack_public_path__ + "static/media/BFH_Logo-02.511c0410.jpg";